<template>
  <v-dialog v-model="dialog"
            max-width="500">
    <template v-slot:activator="{on, attrs}">
      <v-btn block
             id="btn_dynamics"
             v-bind="attrs"
             v-on="on">
        Dynamics CRM
      </v-btn>
    </template>
    <v-form @submit.prevent="submit">
      <v-card>
        <v-card-title>
          Enter your Microsoft Dynamics organization
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field v-model="form.subdomain"
                            placeholder="mycompany"
                            autocomplete="off"
                            required
                            :rules="[rules.required]"
                            :error-messages="form.errors.get('subdomain')"
                            suffix=".">
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select v-model="form.domain"
                        :items="dynamicsDomains"
                        required
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('domain')">
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy"
                 block>
            Go
          </v-btn>
        </v-card-actions>
        <v-progress-linear v-if="form.busy"
                           indeterminate>
        </v-progress-linear>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {Form} from 'vform';
import oktaService from '../../../../../ml/services/oktaService';
import URI from 'urijs';
import formValidation from '../../../plugins/formValidation';
import dynamicsService from '../../../../../ml/services/dynamicsService';

export default {
  mixins: [formValidation],
  data() {
    return {
      dialog: false,
      domains: oktaService.getDomains(),
      dynamicsDomains: [
        'crm.dynamics.com',
        'crm1.dynamics.com',
        'crm2.dynamics.com',
        'crm3.dynamics.com',
        'crm4.dynamics.com',
        'crm5.dynamics.com',
        'crm6.dynamics.com',
        'crm7.dynamics.com',
        'crm8.dynamics.com',
        'crm9.dynamics.com',
      ],
      form: new Form({
        subdomain: '',
        domain: 'crm.dynamics.com',
      }),
    }
  },
  created() {
    this.initForm();
  },
  methods: {
    initForm() {
      dynamicsService.getSavedDomain()
        .then(object => {
          if (object) {
            this.form.subdomain = object.subdomain ? object.subdomain : '';
            this.form.domain = object.domain ? object.domain : 'crm.dynamics.com';
          }
        })
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      this.form.busy = true;
      dynamicsService.saveDomain(this.form.subdomain, this.form.domain)
        .then(() => {
          const crmHostname = `${this.form.subdomain}.${this.form.domain}`;
          let uri = (new URI('/login/dynamics'));
          uri.setQuery({crm_hostname: crmHostname});
          window.location.assign(uri.toString());
          return uri;
        })
        .catch(err => {
          if (err.response) {
            this.form.setErrors(err.response.data);
          }
          this.form.busy = false;
        })
    }
  }
}
</script>
